import React, { FC, useCallback, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { ProductType } from '../../interfaces/api/Stock';
import useStock from '../../hooks/api/useStock';
import { Skeleton } from '@material-ui/lab';
import Domain from 'src/interfaces/api/Domain';

interface Props {
  value?: string;
  error?: boolean;
  required?: boolean;
  helperText?: string;
  className?: any;
  domainId?: Domain['id'];
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const ProductTypeSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, domainId, className, helperText, value, required, ...props }, ref) => {
    const [productTypes, setProductTypes] = useState<ProductType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();

    const { getProductTypes } = useStock();

    useEffect(() => {
      getProductTypes()
        .then((collection) => {
          setProductTypes(collection.items);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }, []);

    const sortProductType = (productTypeA: ProductType, productTypeB: ProductType) => {
      return productTypeA.name.localeCompare(productTypeB.name);
    };

    const getProductTypesByDomain = useCallback(
      () => productTypes.filter((productType) => productType.domainId === domainId).sort(sortProductType),
      [domainId, productTypes]
    );

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl
        ref={ref}
        variant='outlined'
        className={className}
        error={props.error}
        disabled={!domainId}
        required={required}
        {...props}
        fullWidth
      >
        <InputLabel>Produit impacté</InputLabel>
        <Select native label='Produit impacté *' onChange={onChange} value={value}>
          <option value='' />
          {getProductTypesByDomain().map((productType, key) => (
            <option key={key} value={productType.name}>
              {productType.name}
            </option>
          ))}

          {value && !productTypes.map((type) => type.name).includes(value) && <option value={value}>{value}</option>}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default ProductTypeSelect;
